<template lang="pug">
  .add-wa-form
    y-dialog(fill-height fluid v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-5.primary
          v-row(no-gutters)
            v-col
              p.mb-0.title.white--text {{ page ? 'Edit Store Page' : 'Create Store Page' }}
            v-col.shrink
              v-btn.mr-n2(text icon @click="showModal = !showModal" height)
                v-icon(color="white" :size="24") mdi-close

        v-card-text.pa-0(id="froala_container")
          v-form.pa-4(ref="form")
            template(v-if="member.role !== 'Agent' && member.role !== 'Salesperson'")
              .form-name
                v-text-field.mt-2(v-model='pageTitle' :label="$t('form_name.label')" :placeholder="$t('form_name.placeholder')" outlined dense :rules="rules.not_empty" counter :maxlength="100" @blur="updateSlug")

              .form-slug
                v-text-field.mb-4(v-model='pageSlug' :label="$t('form_slug.label')" :placeholder="$t('form_slug.placeholder')" outlined dense :rules="rules.slug" counter :maxlength="100")

              p.title.mb-0 Choose WhatsApp Form
              v-select(ref="layoutSelect" v-model="pageForm" item-text="name" return-object :items="forms" outlined dense :rules="rules.has_quantity" :loading="isFetchingForms")
                template(v-slot:item="{ index, item }")
                  v-layout
                    v-col.px-0.text-left
                      div {{ item.name }}
                      div.grey--text.body-2.text--darken-1.mb-0
                        span.mr-2 Products: {{ item.products.length }}
                        span.mr-2 Clicks: {{ item.total_clicks }}
                        span.mr-2 Sales: {{ item.total_sales | displayPrice }}
              p.title.mb-0 Edit Page Content
              froala.my-12(id="edit" :tag="'textarea'" :config="config" v-model="pageHtml")

        v-divider
        v-card-actions
          v-spacer
          v-btn(color='grey', text @click='showModal = false')
            | Cancel
          v-btn.mr-2(color='accent' filled depressed height=32 :loading="isLoading" @click="clickSave")
            div(v-if="page") {{ $t('save') }}
            div(v-else) {{ $t('create') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'AddYezzaPage',
  props: ['open', 'company', 'page'],
  data: vm => ({
    pageTitle: '',
    pageSlug: '',
    pageForm: null,
    forms: [],
    isFetchingForms: false,
    isLoading: false,
    config: {
      events: {
        'image.beforeUpload' (files) {
          var editor = this
          if (!files.length) { return }
          let file = files[0]
          let fileReader = new FileReader()
          fileReader.onload = e => {
            let image = new Image()
            image.onload = () => {
              let canvas = document.createElement('canvas')
              let maxSize = 960
              let width = image.width
              let height = image.height
              let resizeFactor = 1.0
              if (width > maxSize || height > maxSize) {
                if (height > width) {
                  resizeFactor = maxSize / height
                } else {
                  resizeFactor = maxSize / width
                }
              }
              let resizeWidth = width * resizeFactor
              let resizeHeight = height * resizeFactor
              canvas.width = resizeWidth
              canvas.height = resizeHeight
              canvas.getContext('2d').drawImage(image, 0, 0, resizeWidth, resizeHeight)
              canvas.toBlob((blob) => {
                const resizeImageFile = new File([blob], 'product_image.jpeg', {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                })
                var params = new FormData()
                params.append('file', resizeImageFile)
                vm.$axios.post(`/documents/`, params)
                  .then(resp => {
                    console.log(resp.data)
                    editor.image.insert(resp.data.file, false, null, editor.image.get())
                  })
                  .catch(() => {
                    this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
                  })
              }, 'image/jpeg', 1)
            }
            image.src = e.target.result
          }
          fileReader.readAsDataURL(file)
          return false
        }
      },
      key: process.env.VUE_APP_FROALA_API_KEY,
      attribution: false,
      codeBeautifierOptions: {
        indent_inner_html: false,
        indent_size: 4
      },
      codeMirrorOptions: {
        indent_inner_html: false,
        indent_size: 4
      },
      // scrollableContainer: '#froala_container',
      toolbarButtons: 	{
        'moreRich': {
          'buttons': ['fontSize', 'insertImage', 'insertVideo', 'alignLeft', 'alignCenter', 'alignRight', 'bold', 'textColor', 'italic', 'underline', 'strikeThrough', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting', 'formatOLSimple', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'lineHeight', 'quote',  'insertTable', 'emoticons', 'fontAwesome', 'insertHR'],
          'buttonsVisible': vm.$vuetify.breakpoint.xs ? 3 : 6
        },
        'moreMisc': {
          'buttons': ['undo', 'fullscreen', 'html'],
          'align': 'right',
          'buttonsVisible': 3
        }
      },
      toolbarSticky: false,
      zIndex: 2501,
      quickInsertEnabled: false,
      imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
      videoInsertButtons: ['videoBack', '|', 'videoByURL'],
    },
    pageHtml: '',
    rules: {
      not_empty: [v => (v || '').length > 0 || 'This field is required'],
      slug: [
        v => (v || '').length > 0 || `This field is required`,
        v => /^[a-zA-Z0-9-]*?$/.test(v) || 'Slug must be valid',
        v => v.charAt(v.length - 1) != '-' || `Must not end with '-' sign`,
      ],
      has_quantity: [(v) => !!v || 'Form is required', (v) => v != 0|| 'Form is required']
    }
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    currentPage: {
      get() {
        return this.page
      },
      set(newValue) {
        this.$emit('update:page', newValue)
      }
    }
  },
  mounted () {
    this.fetchForms()
    if (this.page) {
      this.pageTitle = this.page.title
      this.pageSlug = this.page.slug
      this.pageHtml = this.page.content_html
      this.pageForm = this.page.form
    }
  },
  watch: {
    pageSlug (val) {
      this.pageSlug = val.toLowerCase().replace(/[\W_]+/g, ' ').replace(/ /g, '-')
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms() {
      this.isFetchingForms = true
      this.$axios.get(`/forms?page_size=100&company=${this.company.id}&has_product=true`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.forms = resp.data.results
            this.forms.forEach(form => {
              if (form.id == this.pageForm) {
                this.pageForm = form
              }
            })
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingForms = false
        })
    },
    updateSlug () {
      if (this.pageSlug || !this.pageTitle) {
        return
      }
      this.pageSlug = this.pageTitle
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.pageHtml) {
        this.showMessage(['error', this.$t('error_message.page_content_not_empty')])
        return
      }
      this.isLoading = true
      const params = {
        company : this.company.id,
        title : this.pageTitle,
        slug : this.pageSlug,
        form : this.pageForm.id,
        content_html: this.pageHtml.split('font-family').join('font')
      }
      if (this.page) {
        this.axios.put(`/store/settings/${this.company.slug}/pages/${this.page.slug}/`, params)
        .then(resp => {
          this.currentPage = resp.data
          this.showMessage(['success', this.$t('success_message.page_updated')])
          this.showModal = false
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.message) {
            this.showMessage(['error', e.response.data.message])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/store/settings/${this.company.slug}/pages/`, params)
        .then(resp => {
          this.$emit('added', resp.data)
          this.showMessage(['success', this.$t('success_message.page_created')])
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
</style>

<i18n>
{
  "en": {
    "form_name": {
      "label": "Page Name",
      "placeholder": "Write page name here"
    },
    "form_slug": {
      "label": "Page Slug",
      "placeholder": "Write page slug here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "Name",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "Phone",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "Email",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save",
    "create": "Create"
  },
  "ms": {
    "form_name": {
      "label": "Form Name",
      "placeholder": "Write form name here"
    },
    "form_slug": {
      "label": "Form URL",
      "placeholder": "Write custom form URL here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "Nama",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "No Telefon",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "E-mel",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save",
    "create": "Create"
  },
  "zh": {
    "form_name": {
      "label": "Form Name",
      "placeholder": "Write form name here"
    },
    "form_slug": {
      "label": "Form URL",
      "placeholder": "Write custom form URL here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "姓名",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "电话号码",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "电子邮件",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save",
    "create": "Create"
  },
  "ta": {
    "form_name": {
      "label": "Form Name",
      "placeholder": "Write form name here"
    },
    "form_slug": {
      "label": "Form URL",
      "placeholder": "Write custom form URL here"
    },
    "customer_info": "Data Collection",
    "customer_expalain": "Check or add any extra information that should appear on your customer form.",
    "customer_name": {
      "label": "பெயர்",
      "placeholder": "Customer name"
    },
    "customer_phone": {
      "label": "தொலை பேசி இலக்கம்",
      "placeholder": "Customer phone no"
    },
    "customer_email": {
      "label": "மின் அஞ்சல்",
      "placeholder": "Customer email"
    },
    "info": {
      "label": "Info Name",
      "placeholder": "Write extra info name here"
    },
    "add_fields": "+ Collect Extra Info",
    "edit_message_template": "Edit Message Template",
    "attach_products": "Attach Product",
    "whos_selling": "Who's Selling",
    "save": "Save",
    "create": "Create"
  },
  "id": {
    "form_name": {
      "label": "Nama Halaman",
      "placeholder": "Tulis nama halaman di sini"
    },
    "form_slug": {
      "label": "URL form",
      "placeholder": "Tulis URL form khusus di sini"
    },
    "customer_info": "Pengumpulan Data",
    "customer_explain": "Cek atau tambah informasi lainnya yang perlu tampil dalam form pelanggan.",
    "customer_name": {
      "label": "Nama",
      "placeholder": "Nama pelanggan"
    },
    "customer_phone": {
      "label": "Telepon",
      "placeholder": "Nomor HP pelanggan"
    },
    "customer_email": {
      "label": "Email",
      "placeholder": "Email Pelanggan"
    },
    "info": {
      "label": "Nama Info",
      "placeholder": "Tulis nama info tambahan disini"
    },
    "add_fields": "+ Tambah info lebih",
    "attach_products": "Lampirkan produk",
    "whos_selling": "Penjual",
    "save": "Simpan",
    "create": "Create"
  }
}
</i18n>
